<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Sensores</h4>
            <div class="small text-muted">Adminsitración de todos los sensores asignados a los clientes</div>
          </b-col>
          <b-col cols="auto" class="d-flex align-items-center">
            <WidgetVisibilityConfig
              :widgets="widgetsMeta"
              :hidden="hiddenWidgets"
              :disabled="!visibilityLoaded"
              :locked="editingLocked"
              @toggle="onToggleWidget"
              @reset="resetWidgetsVisibility"
              @toggle-lock="setEditingLocked($event)"
            />
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col lg="9">
          <WidgetMasonry
            v-if="visibilityLoaded"
            v-model="widgetsOrdered"
            :disabled="!visibilityLoaded || editingLocked"
            @order-end="saveWidgetOrder"
            @resize-end="commitWidgetSize"
          >
            <template v-slot:default="{ item }">
                <Widget
                  :configWidget="configWidget"
                  :reference="item.reference"
                  :hasAccess="item.hasAccess"
                  :allowHide="!editingLocked"
                  :allowDrag="!editingLocked"
                  :allowResize="!editingLocked"
                  @hide-widget="hideWidget"
                />
            </template>
          </WidgetMasonry>
        </b-col>
        <b-col lg="3">
          <b-list-group class="mb-1" v-if="configSubView.elements.associate">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openAssociate()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Asignar Sensor</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Asigne un sensor a un cliente
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="configSubView.elements.sensors">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openListSensors()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Monitor Cliente</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Revise los sensores de cada cliente
              </p>
            </b-list-group-item>
          </b-list-group>  

          <b-list-group class="mb-1" v-if="configSubView.elements.tanks">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openCrudTanks()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Tanques</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Administración de los tanques
              </p>
            </b-list-group-item>
          </b-list-group>

          <b-list-group class="mb-1" v-if="configSubView.elements.configurations">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openConfigurations()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Configuraciones</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Configuración de bases y nodos.
              </p>
            </b-list-group-item>
          </b-list-group>  

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>          
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import WidgetVisibilityConfig from '@/components/inc/widget/WidgetVisibilityConfig'
  import WidgetMasonry from '@/components/inc/widget/WidgetMasonry'
  import DashboardWidgetsHelper from '@/components/inc/widget/DashboardWidgetsHelper'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    mixins: [DashboardWidgetsHelper],
    components: {
      Widget,
      WidgetVisibilityConfig,
      WidgetMasonry
    },
    data: () => {
      return {
        access: {
          module_id: Modules.SENSORES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.SENSORES,
          profile_id: Profiles.PERSONAL,
          elements: {}
        },
        configSubView: {
          module_id: Modules.SENSORES,
          profile_id: Profiles.PERSONAL,
          elements: {
            associate: true,
            sensors: true,
            tanks: true,
            configurations: true,
            php_custom: true,
          }
        },           
        primaryColor: '',
        arr: {
          PHPCustom: []
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      this.initDashboardWidgets()

      

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.associate = Helper.showAccessView(this.configSubView, 'crudSensorsAssociateTankCustomer')                              
      this.configSubView.elements.sensors = Helper.showAccessView(this.configSubView, 'listSensorsTankCustomer')                              
      this.configSubView.elements.tanks = Helper.showAccessView(this.configSubView, 'crudTank')                              
      this.configSubView.elements.configurations = Helper.showAccessView(this.configSubView, 'configurations')                                    
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */                                 
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    }, 
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },         
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      }, 
      openAssociate() {
        this.$router.push({ name: 'SensorsStaffCrudSensorsAssociateTankCustomer' })
      },
      openCrudTanks() {
        this.$router.push({ name: 'SensorsStaffCrudTank' })
      },
      openListSensors() {
        this.$router.push({ name: 'SensorsStaffListSensorsTankCustomer' })
      },
      openConfigurations() {
        this.$router.push({ name: 'SensorsStaffConfigurations' })
      },


      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.SENSORES)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }    
   
  }
</script>

<style>

</style>
